export default "__VITE_ASSET__Dhqo4TlP__"